export const productImage =
  "https://cdn.magicpatterns.com/uploads/3GtS742T8YkEvxduiDncfm/Collage_de_squishies_de_papel_kawaii.webp";

export const coverImage =
  "https://cdn.magicpatterns.com/uploads/aBvnBuk9Txsx4FVxgeog7f/Redesigning_ebook_cover_for_ebook_a7c40ee8_2K.webp";

export const galleryImage =
  "https://cdn.magicpatterns.com/uploads/5N7rvRpztoCmayEK5ySkSp/Collage_kawaii_de_papel_imprimible.webp";

export const demonstrationVideo =
  "https://cdn.magicpatterns.com/uploads/bgvFvCjBYYzB5rKBq9LRVU/WEB.mp4";

export const materialPreviewVideo =
  "https://cdn.magicpatterns.com/uploads/m7AzzyaL7LJxs9VcYdPx3H/SQUISHIES_LIBRO_10SEG.mp4";

export const logoImage =
  "https://cdn.magicpatterns.com/uploads/hKyEraGP7c4Pj4ftkMVXzj/Mundo_de_Papel__Logo_3D_Colorido.webp";

export const designCarouselImages = [
  { src: "https://cdn.magicpatterns.com/uploads/dVpw34jsaAomnH63rU1Q27/Hand_touching_paper_dumpling_squ…_b558b423.webp", alt: "Squishy de dumpling de papel" },
  { src: "https://cdn.magicpatterns.com/uploads/3V1yr72LpRUkD8m2jUFUsm/Hands_squeezing_paper_capybara_s…_2ecb7a7d.webp", alt: "Squishy de capibara de papel" },
  { src: "https://cdn.magicpatterns.com/uploads/9P2pXrmJ8FxHAE8oURFLVV/Hands_pressing_paper_sandwich_sq…_e94ec0f1.webp", alt: "Squishy de sándwich de papel" },
  { src: "https://cdn.magicpatterns.com/uploads/2YPCHcUnkcyvNSkfWn2Xzw/Hands_pressing_paper_butter_squishy_e9481bd8.webp", alt: "Squishy de manteca de papel" },
  { src: "https://cdn.magicpatterns.com/uploads/7magFoUvYx7P7Hj3nMw4C4/Hands_squeezing_paper_toy_b04d9b05.webp", alt: "Squishy de juguete de papel" },
  { src: "https://cdn.magicpatterns.com/uploads/w8S3jX5xhBHNNWdSEtHpNs/Hands_squeezing_paper_fries_squishy_34b3a359.webp", alt: "Squishy de papas fritas de papel" },
  { src: "https://cdn.magicpatterns.com/uploads/uampor2wPC1snAMM624Va5/Hand_squeezing_paper_pyramid_squ…_8d014559.webp", alt: "Squishy de pirámide de papel" },
  { src: "https://cdn.magicpatterns.com/uploads/qZZ1bGCRfahzt42jQ7Yj3K/Hands_pressing_paper_fried_egg_0394cc61.webp", alt: "Squishy de huevo frito de papel" },
  { src: "https://cdn.magicpatterns.com/uploads/bY4kx4hzgm8znYhaRnANHo/Hands_pressing_paper_phone_squishy_cdf741c4.webp", alt: "Squishy de teléfono de papel" },
  { src: "https://cdn.magicpatterns.com/uploads/1trtSfrYWbdtoDbLoAfLGc/Hands_holding_paper_squishy_deb47325.webp", alt: "Squishy de papel hecho a mano" },
  { src: "https://cdn.magicpatterns.com/uploads/gPddm14ik1dK7DHQ5JkFjt/Hands_squeezing_paper_avocado_sq…_f9bb97a5.webp", alt: "Squishy de palta de papel" },
];

export const painPoints = [
  {
    title: "¿Un ratito más de celular?",
    text: "Querés que se entretenga con algo diferente, sin terminar siempre frente a una pantalla.",
  },
  {
    title: "¿Otra vez buscando plantillas?",
    text: "Le encanta hacer squishies, pero encontrar diseños nuevos para imprimir termina siendo siempre lo mismo.",
  },
  {
    title: "¡No sé qué hacer!",
    text: "Las mismas actividades aburren rápido y cada tarde hay que inventar algo nuevo.",
  },
];

export const steps = [
  { title: "Imprimí", text: "Elegí tu diseño favorito en A4." },
  { title: "Pintá", text: "Dale tus propios colores." },
  { title: "Recortá", text: "Seguí las líneas de la plantilla." },
  { title: "Rellená y armá", text: "Usá cinta y un relleno suave." },
  { title: "¡Jugá!", text: "Apretá y coleccioná tus creaciones." },
];

export const exampleComments = [
  { author: "Florencia M.", comment: "Se la pasa mirando videos de squishies jajaja. Me encantó la idea de que ahora pueda hacer los suyos en vez de estar tanto con el celu 😍" },
  { author: "Romina G.", comment: "Mi nena se re enganchó con los de comida 😂 Ya tiene una lista de todos los que quiere hacer." },
  { author: "Sabrina L.", comment: "Lo bueno es que están las líneas para recortar y doblar. Yo pensé que iba a ser complicado pero se entiende re bien." },
  { author: "Carla P.", comment: "Está buenísimo tener tantos modelos para elegir. Los puede pintar como quiere y cada uno le queda distinto 💕" },
  { author: "Natalia R.", comment: "Me encanta como actividad para un día de lluvia. Entre pintar, recortar y armar se entretienen un montón." },
  { author: "Mariana S.", comment: "Lo mejor es poder imprimir los favoritos otra vez. Siempre quieren repetir alguno o hacerlo de otro color jajaja." },
  { author: "Luciana B.", comment: "Los de Butter y Dumpling son una ternura 😍 Encima quedan re lindos cuando los terminás." },
  { author: "Andrea F.", comment: "Me parece una idea hermosa para hacer algo juntos en casa. Después están orgullosos mostrando lo que hicieron ❤️" },
];

export const bonusItems = [
  { image: "https://cdn.magicpatterns.com/uploads/q1D7Y5BG2cMSKF9WzK5msc/mockup-guia-rapida-de-armado.png", title: "Guía rápida de armado", description: "Aprendé a recortar, doblar, rellenar y sellar tus squishies con consejos prácticos para conseguir creaciones suaves, infladitas y bien terminadas.", value: "AR$ 14.990" },
  { image: "https://cdn.magicpatterns.com/uploads/jUN6y7JTd8uGRzTg2vVpyT/mockup-plantillas-para-imprimir-y-repetir.png", title: "Guía para imprimir y reutilizar", description: "Descubrí cómo imprimir correctamente en A4, organizar tus archivos, ahorrar papel y volver a crear tus diseños favoritos todas las veces que quieras.", value: "AR$ 9.990" },
  { image: "https://cdn.magicpatterns.com/uploads/ojkWRfCq5bX7uqZXda5N8B/mockup-ideas-de-juego-con-squishies.png", title: "30 Juegos y Retos con Squishies", description: "Disfrutá 30 actividades, desafíos, juegos de memoria e ideas creativas para seguir divirtiéndose con los squishies después de armarlos.", value: "AR$ 7.990" },
  { image: "https://cdn.magicpatterns.com/uploads/uSBFjVhkwux4LnzyA3kRXQ/mockup-calendario-de-30-dias-creativos.png", title: "Calendario de 30 Días Creativos", description: "Un desafío creativo para cada día, con actividades para completar, marcar los avances y mantener la diversión durante todo el mes.", value: "AR$ 9.990" },
  { image: "https://cdn.magicpatterns.com/uploads/p2S1qkAnqzcyPyaH3DZdr8/mockup-pasaporte-del-coleccionista-squishy.png", title: "Pasaporte del Coleccionista Squishy", description: "Registrá tus creaciones, marcá los diseños terminados, elegí tus favoritos y celebrá tus logros mientras completás la colección.", value: "AR$ 11.990" },
];

export const faqs = [
  {
    question: "¿Es un producto físico?",
    answer: "No. Es un pack digital de plantillas que recibís para descargar e imprimir en casa.",
  },
  {
    question: "¿Qué materiales necesito?",
    answer: "Hojas A4, una impresora, colores, tijeras, cinta adhesiva y material de relleno suave.",
  },
  {
    question: "¿Los diseños están listos para imprimir?",
    answer: "Sí. Las plantillas están preparadas para imprimir en formato A4.",
  },
  {
    question: "¿Puedo imprimirlos más de una vez?",
    answer: "Sí. Podés conservar los archivos y volver a imprimirlos para uso personal.",
  },
  {
    question: "¿Los diseños vienen pintados?",
    answer: "El pack principal incluye plantillas para pintar y personalizar. También puede estar disponible una versión a color como adicional opcional durante la compra.",
  },
  {
    question: "¿Cómo recibo el producto?",
    answer: "Recibís el acceso al material digital por correo electrónico una vez confirmado el pago.",
  },
];
